import type {
  CampaignStats,
  EnhancedMessageTrackingData,
} from './types';
import {
  hadSuccessfulDelivery,
  hasOpenedEvent,
  hasClickedEvent,
  hasBounceEvent,
  hasComplaintEvent,
  roundToTwo,
} from '../../utils/engagementAnalytics';

export const buildStatsFromTracking = (
  campaignId: string,
  tracking: EnhancedMessageTrackingData[]
): CampaignStats | null => {
  if (!tracking.length) {
    return null;
  }

  let delivered = 0;
  let opened = 0;
  let clicked = 0;
  let bounced = 0;
  let complained = 0;

  tracking.forEach((record) => {
    if (hadSuccessfulDelivery(record)) {
      delivered += 1;
    }
    if (hasOpenedEvent(record)) {
      opened += 1;
    }
    if (hasClickedEvent(record)) {
      clicked += 1;
    }
    if (hasBounceEvent(record)) {
      bounced += 1;
    }
    if (hasComplaintEvent(record)) {
      complained += 1;
    }
  });

  const totalSent = tracking.length;
  const timestamp = new Date().toISOString();

  return {
    campaignId,
    totalSent,
    delivered,
    opened,
    clicked,
    bounced,
    complained,
    unsubscribed: 0,
    deliveryRate:
      totalSent > 0 ? roundToTwo((delivered / totalSent) * 100) : 0,
    openRate: delivered > 0 ? roundToTwo((opened / delivered) * 100) : 0,
    clickRate: delivered > 0 ? roundToTwo((clicked / delivered) * 100) : 0,
    bounceRate: totalSent > 0 ? roundToTwo((bounced / totalSent) * 100) : 0,
    complaintRate:
      delivered > 0 ? roundToTwo((complained / delivered) * 100) : 0,
    provider: 'ses',
    providers: undefined,
    engagementRate:
      delivered > 0 ? roundToTwo(((opened + clicked) / delivered) * 100) : 0,
    clickToOpenRate: opened > 0 ? roundToTwo((clicked / opened) * 100) : 0,
    lastUpdated: timestamp,
  };
};
